import {useState} from 'react';
import {FolderOutlined} from '@ant-design/icons';
import MoveModal from './MoveNoteSelectionModal';
import type {Note} from '../types/note';

import {ROOT_LEVEL} from "../utils/constants";

interface CategorySelectorProps  {
    selectedCategoryId: number,
    note?: Note,
    onCategoryChange: (categoryId: number) => void,
    categoryBreadcrumb?: string
}

export function CategorySelector({
                                     selectedCategoryId,
                                     note,
                                     onCategoryChange,
                                     categoryBreadcrumb
                                 }: CategorySelectorProps) {
    const [isOpen, setIsOpen] = useState(false);
    const [categoryPath, setCategoryPath] = useState<string>(categoryBreadcrumb ? categoryBreadcrumb : note?.category_breadcrumb?.join(' > ') || ROOT_LEVEL.name);

    return (
        <div className="relative">
            <div 
                onClick={() => setIsOpen(true)}
                className="flex items-center gap-2 w-full cursor-pointer group hover:opacity-90 transition-all"
                role="button"
                aria-label="Click to select category"
            >
                <div className="px-3 py-2 bg-[#048ba8] text-white rounded-lg group-hover:bg-[#037893] transition-colors">
                    <FolderOutlined/>
                </div>
                <div className="flex-1 relative">
                    <input
                        type="text"
                        value={categoryPath}
                        readOnly
                        placeholder="Click here to select a category"
                        className="w-full p-2 rounded-lg border border-gray-300 dark:border-gray-600 bg-gray-50 dark:bg-gray-800 text-gray-900 dark:text-white group-hover:border-[#048ba8] dark:group-hover:border-[#f4d35e] cursor-pointer"
                    />
                    <div className="hidden sm:block absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 text-sm">
                        Click to select
                    </div>
                </div>
            </div>

            <MoveModal
                isVisible={isOpen}
                selectedCategoryId={selectedCategoryId}
                onCancel={() => setIsOpen(false)}
                onMove={(id: number, categoryBreadcrumb: string) => {
                    onCategoryChange(id);
                    setCategoryPath(categoryBreadcrumb || ROOT_LEVEL.name);
                    setIsOpen(false);
                }}
                modalTitle="Select Category"
            />
        </div>
    );
}
